import axiosInstance from './axios-instance';
import { isMutationSuccess } from './cache-utils';
import { invalidateOrderDataCache, resolveClientId, resolveOrderId } from './cache-invalidation';

const getScopedAccountId = (accountId?: number): number => {
  if (typeof window === 'undefined') {
    return Number(accountId || 0);
  }
  const ownerAccountId = Number(localStorage.getItem('ownerAccountId') || '0');
  if (ownerAccountId > 0) {
    return ownerAccountId;
  }
  if (Number(accountId) > 0) {
    return Number(accountId);
  }
  return Number(localStorage.getItem('accountId') || '0');
};

const isFormDataPayload = (payload: any): payload is FormData =>
  typeof FormData !== 'undefined' && payload instanceof FormData;

const withScopedAccountId = (payload: any) => {
  if (!payload) {
    return payload;
  }

  if (isFormDataPayload(payload)) {
    const rawAccountId = payload.get('accountId');
    const parsedAccountId =
      typeof rawAccountId === 'string' && Number.isFinite(Number(rawAccountId))
        ? Number(rawAccountId)
        : 0;
    const scopedAccountId = getScopedAccountId(parsedAccountId);
    if (scopedAccountId > 0) {
      payload.set('accountId', String(scopedAccountId));
    }
    return payload;
  }

  if (typeof payload === 'object') {
    const scopedAccountId = getScopedAccountId((payload as any).accountId);
    if (scopedAccountId > 0) {
      return {
        ...payload,
        accountId: scopedAccountId,
      };
    }
  }

  return payload;
};

const addDraperyOrderUpload = async (payload: any) => {
  try {
    const scopedPayload = withScopedAccountId(payload);
    const response = await axiosInstance.post<any>(`/draperyOrderUpload/add`, scopedPayload);
    if (isMutationSuccess(response.data)) {
      invalidateOrderDataCache(resolveOrderId(scopedPayload, response.data), resolveClientId(scopedPayload, response.data));
    }

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const editDraperyOrderUpload = async (payload: any) => {
  try {
    const scopedPayload = withScopedAccountId(payload);
    const response = await axiosInstance.post<any>(`/draperyOrderUpload/edit`, scopedPayload);
    if (isMutationSuccess(response.data)) {
      invalidateOrderDataCache(resolveOrderId(scopedPayload, response.data), resolveClientId(scopedPayload, response.data));
    }

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

const deleteDraperyOrderUpload = async (payload: any) => {
  try {
    const response = await axiosInstance.post<any>(`/draperyOrderUpload/delete`, payload);
    if (isMutationSuccess(response.data)) {
      invalidateOrderDataCache(resolveOrderId(payload, response.data), resolveClientId(payload, response.data));
    }

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export { addDraperyOrderUpload, editDraperyOrderUpload, deleteDraperyOrderUpload };
